/**
 * 대시보드 서비스
 */

import apiClient from './api';
import { DashboardData } from '../types/dashboard';

export const dashboardService = {
  /**
   * 대시보드 데이터 조회
   */
  async getDashboardData(): Promise<DashboardData> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: DashboardData }>('/admin/dashboard');
    // return response.data.data;
    
    // 임시: 더미 데이터 반환
    return {
      stats: {
        today_revenue: 0,
        today_bookings: 0,
        today_entrances: 0,
        pending_inquiries: 0,
        week_revenue: 0,
        week_bookings: 0,
        month_revenue: 0,
        month_bookings: 0,
      },
      revenue_trend: [],
      booking_trend: [],
      sales_by_hall: [],
      sales_by_package: [],
      recent_activities: [],
      voucher_ticket_status: {
        vouchers_issued_today: 0,
        vouchers_exchanged_today: 0,
        vouchers_expired_today: 0,
        vouchers_cancelled_today: 0,
        tickets_issued_today: 0,
        tickets_used_today: 0,
        tickets_expired_today: 0,
        tickets_cancelled_today: 0,
      },
    };
  },

  /**
   * 바우처/티켓 실시간 현황 조회
   */
  async getVoucherTicketStatus(): Promise<DashboardData['voucher_ticket_status']> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: DashboardData['voucher_ticket_status'] }>('/admin/dashboard/voucher-ticket-status');
    // return response.data.data;
    
    // 임시: 더미 데이터 반환
    return {
      vouchers_issued_today: 0,
      vouchers_exchanged_today: 0,
      vouchers_expired_today: 0,
      vouchers_cancelled_today: 0,
      tickets_issued_today: 0,
      tickets_used_today: 0,
      tickets_expired_today: 0,
      tickets_cancelled_today: 0,
    };
  },
};

